<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans ">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button class="btn btn-light btn-sm my-2 my-sm-0" @click="gotoSingin">
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="py-5 bg-grey200">
			<div class="container">
				<div class="row d-flex justify-content-center">
					<div class="col-md-6">
						<ul class="list-group checkout-list-group">
							<li class="list-group-item">
								<h4 class="text-center">Almost Done!</h4>
								<p class="text-center">
									Review your plan and checkout To start watching
								</p>
							</li>
							<li class="list-group-item">
								<div class="row d-flex  align-items-center justify-content-between">
									<div class="col-auto label-text">
										Payment Method
									</div>
									<div class="col-auto">
										<span v-if="$route.params.paymentmethod == 'paypal'" class="img"><img
												src="../../assets/img/paypal.png" /></span>
										<span v-if="$route.params.paymentmethod == 'visa'" class="img"><img
												src="../../assets/img/visa.png" /></span>
										<span v-if="$route.params.paymentmethod == 'mastercard'" class="img"><img
												src="../../assets/img/mastercard.png" /></span>
										<span v-if="$route.params.paymentmethod == 'glo'" class="img"><img
												src="../../assets/img/Glo_button.png" /></span>
										<span v-if="$route.params.paymentmethod == 'ussd'" class="img"><img
												src="../../assets/img/ussd.png" /></span>
										<span v-if="$route.params.paymentmethod == 'tigo'" class="img"><img
												src="../../assets/img/tigo.png" /></span>
										<span v-if="$route.params.paymentmethod == 'mpesa'" class="img"><img
												src="../../assets/img/mpesa.png" /></span>
										<span v-if="$route.params.paymentmethod == 'mtn'" class="img"><img
												src="../../assets/img/mtn.png" /></span>
									</div>
									<div class="col-auto">
										<a :href="getPaymentHref()" class="btn btn-outline-primary">Edit</a>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div class="row d-flex  align-items-center justify-content-between">
									<div class="col text-center relative">
										<p>Payment plan</p>
										<h1 class="price">
											<small>{{ currentSubs.currency }}</small>
											{{ currentSubs.price }}
										</h1>
										<p class="text-green font-semibold">
											{{ currentSubs.title }}
										</p>
										<a href="/#/packages" class="btn btn-outline-primary edit-btn">Edit</a>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<ul class="list">
									<li>4GB data free</li>
									<li>14 days free subscription</li>
									<li>Unlimited movies and Tv shows</li>
									<li>Watch on your laptop, TV, phone and tablet</li>
									<li>Cancel anytime</li>
								</ul>
							</li>
							<li class="list-group-item">
								<p>
									By checking the checkbox below, you agree to our Terms of Use,
									Privacy Statement, and that you are over 18. You may cancel at
									any time. Ibakatv will automatically continue your membership
									and charge the membership fee (currently ₦{{
										currentSubs.price
									}}) to your payment method on a monthly basis until you
									cancel.
								</p>
								<div class="custom-control custom-checkbox mt-3">
									<input type="checkbox" v-model="checked" class="custom-control-input"
										id="customCheck1" />
									<label class="custom-control-label label-text" for="customCheck1">I Agree</label>
								</div>

								<div class="text-justify py-3">
									<div id="google_captcha"></div>
								</div>
								<div class="text-center">
									<button @click="doSubscribe" class="btn  btn-outline-light" :disabled="!checked || !captchaVerified">
										START MEMBERSHIP
									</button>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<p class="text-center pt-4 label-text">Download App</p>
			<p class="text-center ">
				<img src="../../assets/img/google-play.png" alt="" class="cursor-pointer" @click="gotoAppStore('google')" />
				<img src="../../assets/img/app-store.png" class="ml-2 cursor-pointer" alt=""
					@click="gotoAppStore('apple')" />
			</p>
		</section>
		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-center">
				<a href="#nogo">Home</a>
				<a href="#nogo">Privacy Policy</a>
				<a href="#nogo">Terms of Use</a>
				<a href="#nogo">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>
<script>
export default {
	name: "CheckoutPage",
	components: {},
	created() {
		this.packages = this.$store.state.packages;
		this.currentSubs = this.getCurrentsubs();
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
		this.$store.commit("showPopup", false);
	},
	mounted() {
		grecaptcha.render('google_captcha', {
			'sitekey': '6LcJz8IpAAAAAMVTx2nQGcHj-TBTpJF0c5Gbhn9a',
			'callback': this.captchaCallback
		});
	},
	methods: {
		captchaCallback(response) {
			// secret key to send to serve for verification
			this.$store.dispatch("verifyRecaptchaToken", response)
				.then((response) => {
					this.captchaVerified = true;
				})
				.catch((err) => {
					this.$store.commit(
						"setNotification",
						"Something went wrong please try again later"
					);
				});

		},
		gotoAppStore(type) {
			if (type == "google") {
				window.open(
					"https://play.google.com/store/apps/details?id=com.ibakatv.mobile",
					"_blank"
				);
			} else if (type == "apple") {
				window.open(
					"https://apps.apple.com/gm/app/ibakatv/id1060646446",
					"_blank"
				);
			}
		},
		getCurrentsubs() {
			let cp = this.packages.find((ele) => ele.id == this.$route.params.pid);
			return cp.subscriptions.find((ele) => ele.id == this.$route.params.sid);
		},
		getcurrentpackage() { },
		getPaymentHref() {
			return (
				"/#/selectpayment-dsp/" +
				this.$route.params.sid +
				"/" +
				this.$route.params.pid
			);
		},
		gotoSingin() {
			this.$router.push("/login");
		},
		doSubscribe() {


			this.$router.push(
				"/payment/" +
				this.$route.params.sid +
				"/" +
				this.$route.params.pid
			);

		},
	},

	data() {
		return {
			checked: false,
			currentSubs: null,
			currentpackages: null,
			showforgotpasswordErr: false,
			forgotpasswordErr: "",
			isActive: false,
			doforgotpassword: true,
			userid: "",
			password: "",
			packages: null,
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
			captchaVerified: false
		};
	},
};
</script>
<style scoped>
a.disabled {
	pointer-events: none;
	cursor: default;
}

.cursor-pointer {
	cursor: pointer;
}

.py-5 {
	padding-top: 8rem !important;
	padding-bottom: 8rem !important;
	min-height: 100vh !important;
}
</style>
